<template>
  <div class="weibo">
    <div class="blog">
      <p class="title">{{ content.title }}</p>
      <p class="content"
         v-for="(item,index) of content.items"
         :key="index"
      >{{ item.content }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'blog-detail',
    props: {
      content: {}
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~stylus/variable"

  .weibo
    .blog
      .title
        line-height: 180%
        margin: 8px
        font-size: $fontsize-large
        color: $color-dark-grey
      .content
        line-height: 28px
        padding: 8px
        font-size: $fontsize-large
        color: $color-dark-grey
        white-space: pre-wrap
</style>
